import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import { images, isConceptVisual } from "@/content/images";
import { useLanguage } from "@/context/LanguageContext";

export default function About() {
  const { t } = useLanguage();
  const a = t.aboutPage;

  return (
    <div className="bg-[#faf8f5] text-slate-900 antialiased min-h-screen">
      <Seo page="about" />
      <Header />

      <section className="hero-grid-pat py-20 border-b spec-border" data-testid="about-hero">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <span className="text-xs font-mono-spec text-gold-700 font-semibold tracking-[0.18em] uppercase">{a.eyebrow}</span>
          <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-slate-950 mt-3 leading-[1.1]">{a.title}</h1>
          <p className="text-lg text-slate-600 mt-5 leading-relaxed">{a.intro}</p>
          <div className="mt-10 bg-white border spec-border p-3 shadow-md rounded-sm max-w-2xl">
            <div className="rounded-sm overflow-hidden">
              <img
                src={images.banner}
                alt="Lidlink Kampagnenmotiv"
                data-testid="about-banner"
                className="w-full object-cover"
                loading="lazy"
              />
            </div>
            {isConceptVisual && (
              <p className="mt-3 text-[11px] text-slate-500 font-mono-spec px-1 pb-1">{t.hero.imageCaptionConcept}</p>
            )}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white border-b spec-border" data-testid="about-pilot">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <h2 className="text-2xl font-bold tracking-tight text-slate-950 mb-4">{a.pilotTitle}</h2>
          <p className="text-base text-slate-600 leading-relaxed">{a.pilotText}</p>
        </div>
      </section>

      <section className="py-16 bg-slate-100/60 border-b spec-border" data-testid="about-principles">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <h2 className="text-2xl font-bold tracking-tight text-slate-950 mb-8">{a.principlesTitle}</h2>
          <div className="grid sm:grid-cols-2 gap-6">
            {a.principles.map((p) => (
              <div key={p.t} className="p-6 bg-white border spec-border rounded-sm">
                <h3 className="text-base font-bold text-slate-950">{p.t}</h3>
                <p className="text-sm text-slate-600 mt-2 leading-relaxed">{p.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white" data-testid="about-contact">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <h2 className="text-2xl font-bold tracking-tight text-slate-950 mb-4">{a.contactTitle}</h2>
          <p className="text-base text-slate-600 leading-relaxed mb-6">{a.contactText}</p>
          <Link
            to="/#contact"
            data-testid="about-contact-cta"
            className="inline-flex items-center justify-center px-6 py-3.5 bg-slate-950 text-white text-sm font-semibold rounded-sm hover:bg-gold-800 transition-colors shadow-md"
          >
            {a.contactCta}
          </Link>
          <p className="text-xs font-mono-spec text-slate-500 mt-6">
            {a.legalNote}{" "}
            <Link to="/impressum" data-testid="about-imprint-link" className="text-gold-700 hover:underline">
              Impressum
            </Link>
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
